import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, ResponsiveContainer } from 'recharts';
import { range } from 'lodash-es';
/* Constants */
import { CHART_SETTINGS } from 'client/site-modules/core-page/constants/crowdsourced-deals';
/* Utils */
import { tickFormatter, getFormattedChartData } from 'client/site-modules/core-page/utils/crowdsourced-deals-utils';
/* Hooks */
import { useToggle } from 'site-modules/shared/hooks/use-toggle';

import './crowdsourced-chart.scss';

export function CrowdsourcedChart({ isMobile = false, chal = 'ctrl', chartData = null }) {
  const [showRectangle, setShowRectangle] = useToggle(false, { limit: 1 });
  const showChart = !!chartData && !!chartData?.length;

  if (!showChart) return null;

  const dealersChartData = getFormattedChartData(chartData);
  const fillGradient = ['chal-3', 'chal-4'].includes(chal);
  const { POS: rectXPos, TEXT_POS, TEXT_SIZE } = isMobile ? CHART_SETTINGS.RECT.MOBILE : CHART_SETTINGS.RECT.DESKTOP;

  return (
    <div className="crowdsourced-dealers-chart pt-1_5">
      <div className="d-flex flex-column flex-md-row align-items-start">
        <ResponsiveContainer width="100%" height={isMobile ? 150 : 230} debounce={250}>
          <BarChart data={dealersChartData} margin={CHART_SETTINGS.MARGIN}>
            <CartesianGrid strokeDasharray={'0'} vertical={false} strokeWidth={1} />
            <XAxis dataKey="dealerName" hide />
            <YAxis
              type="number"
              axisLine={false}
              tickFormatter={tickFormatter}
              ticks={[...range(0, -14, -2), -14]}
              tick={{ fontSize: 12 }}
              tickLine={false}
              padding={{ top: 8 }}
              interval={0}
            />
            <defs>
              <linearGradient id="colorUv" x1={1} y1={1} x2={0} y2={0}>
                <stop offset="-17.01%" stopColor="#6D1AB8" />
                <stop offset="112.93%" stopColor="#C73C8F" />
              </linearGradient>
            </defs>
            <g className={classNames('top-dealers-rect', { show: showRectangle })}>
              <rect
                width="100%"
                height="100%"
                x={`${rectXPos}%`}
                y="3.5%"
                fillOpacity={0.2}
                fill={fillGradient ? '#CBD4E1' : '#2070E8'}
              />
              <text x={`${TEXT_POS}%`} y="92%" fontSize={TEXT_SIZE}>
                <tspan>Top Dealers</tspan>
              </text>
            </g>
            <Bar
              dataKey="finalPercentOffMsrp"
              animationDuration={1000}
              animationEasing="linear"
              id="crowdsourced-dealers-chart"
              onAnimationEnd={setShowRectangle}
            >
              {dealersChartData.map(entry => (
                <Cell fill={fillGradient ? 'url(#colorUv)' : '#2070E8'} key={entry.dealerName} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

CrowdsourcedChart.propTypes = {
  chartData: PropTypes.arrayOf(PropTypes.shape({})),
  chal: PropTypes.string,
  isMobile: PropTypes.bool,
};
